// extracted by mini-css-extract-plugin
export default {"root":"HeroImage-module--root--1ec2c","image":"HeroImage-module--image--1c3e9"};